module.exports = __webpack_public_path__ + "static/coursesMobileBackground-72365ef8bbf15e5cb0e9add29926195e.jpg";